export const REFERENCE_TYPE_LABELS = {
  invoice: "Invoice",
  challan: "Challan",
  lc: "LC",
  gate_pass: "Gate Pass",
};

export const TRANSPORTATION_COST_TYPES = {
  export: {
    label: "Export",
    path: "/transportation-cost/export",
    referenceTypes: ["invoice", "challan"],
    showSupplier: false,
    filters: [
      { name: "invoice_number", label: "Invoice Number" },
      { name: "challan_number", label: "Challan Number" },
    ],
  },
  import: {
    label: "Import",
    path: "/transportation-cost/import",
    referenceTypes: ["invoice", "lc"],
    showSupplier: true,
    filters: [
      { name: "invoice_number", label: "Invoice Number" },
      { name: "lc_number", label: "LC Number" },
    ],
  },
  local: {
    label: "Local",
    path: "/transportation-cost/local",
    referenceTypes: ["challan", "gate_pass"],
    showSupplier: true,
    filters: [
      { name: "challan_number", label: "Challan Number" },
      { name: "gate_pass_number", label: "Gate Pass Number" },
    ],
  },
};

export const getCostTypeConfig = (costType) => TRANSPORTATION_COST_TYPES[costType] || TRANSPORTATION_COST_TYPES.export;

export const getCostTypeFromPath = (pathname) =>
  Object.keys(TRANSPORTATION_COST_TYPES).find((costType) =>
    pathname.startsWith(TRANSPORTATION_COST_TYPES[costType].path),
  ) || "export";
